import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-property-share-button',
  templateUrl: './property-share-button.component.html',
  styleUrls: ['./property-share-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyShareButtonComponent {
  @Output() handleOpen = new EventEmitter<void>();

  openModal(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.handleOpen.emit();
  }
}
